var _style, _circle, _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#FFDA44;}\n\t.st2{fill:#D80027;}\n\t.st3{fill:#000000;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34.3,128c-11.6,20-20.1,40.9-25.8,62.2l428.1,247.1c15.6-15.6,29.5-33.4,41-53.4L34.3,128z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M384,34.3C281.6-24.8,155.3-5.1,75.4,74.6l428.1,247.1C532.5,212.7,486.4,93.5,384,34.3L384,34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128,477.7c102.4,59.1,228.7,39.4,308.6-40.3L8.6,190.2C-20.5,299.3,25.6,418.5,128,477.7L128,477.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M328.3,228.2c0,39.9-32.4,72.3-72.3,72.3s-72.3-32.4-72.3-72.3c0-12.5,3.1-24.2,8.7-34.4 c-15.7,16.1-25.4,38-25.4,62.2c0,49.2,39.9,89,89,89s89-39.9,89-89c0-24.2-9.7-46.2-25.4-62.2C325.2,204,328.3,215.7,328.3,228.2 L328.3,228.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M239.3,144.7h33.4v166.9h-33.4V144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M311.6,178.1H200.4c0,7.7,6.7,13.9,14.4,13.9h-0.5c0,7.7,6.2,13.9,13.9,13.9c0,7.7,6.2,13.9,13.9,13.9h27.8 c7.7,0,13.9-6.2,13.9-13.9c7.7,0,13.9-6.2,13.9-13.9h-0.5C304.9,192,311.6,185.8,311.6,178.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M178.1,322.8h155.8v33.4H178.1V322.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M289.4,333.9h66.8v33.4h-66.8V333.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M155.8,333.9h66.8v33.4h-66.8V333.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBn);
export default __webpack_public_path__ + "static/media/bn.ce2a7842ecc424fc3ed434b1260659ca.svg";
export { ForwardRef as ReactComponent };